import routerOptions0 from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}